module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_9005.477616e2.png";